import { AwsUi } from '../../../core/runtime/src';
import { Icon } from '../../icon/src';
import { Spinner } from '../../spinner/src';
var iconAlign = function (component) {
    var standalone = component.variant === 'icon';
    return standalone ? 'left' : component.iconAlign;
};
var icon = function (component) {
    if (!component.icon && !component.iconUrl) {
        return;
    }
    var iconClass = ['awsui-button-icon', "awsui-button-icon-" + iconAlign(component)].join(' ');
    return AwsUi.__createElement(Icon, { className: iconClass, name: component.icon, url: component.iconUrl, alt: component.iconAlt });
};
export var leftIcon = function (component) {
    var spinner = function () {
        var spinnerClass = ['awsui-button-icon', 'awsui-button-icon-left'].join(' ');
        return AwsUi.__createElement(Spinner, { className: spinnerClass });
    };
    if (component.loading) {
        return spinner();
    }
    else if (iconAlign(component) === 'left') {
        return icon(component);
    }
};
export var rightIcon = function (component) {
    if (iconAlign(component) === 'right') {
        return icon(component);
    }
};
//# sourceMappingURL=icon.js.map